export default "__VITE_ASSET__9bgSTwIU__"